import { render, staticRenderFns } from "./myDialog4.vue?vue&type=template&id=d59e0f62&scoped=true&"
import script from "./myDialog4.vue?vue&type=script&lang=js&"
export * from "./myDialog4.vue?vue&type=script&lang=js&"
import style0 from "./myDialog4.vue?vue&type=style&index=0&id=d59e0f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59e0f62",
  null
  
)

export default component.exports